<template>
  <v-list nav dense>
    <v-img
      :src="
        settings && settings.logo_url
          ? settings.logo_url
          : require('./assets/' + $t('$assets.fullLogoSmallWhite'))
      "
      contain
      width="144"
      class="my-4 ms-8 d-none d-lg-flex"
    />
    <div class="my-1 d-flex d-lg-none" />
    <template v-for="item in items">
      <v-list-group
        color="sidebarActive"
        v-if="item.subitems"
        :key="item.title"
        v-model="item.model"
        class="mb-1"
      >
        <template v-slot:activator>
          <v-list-item-action class="ms-5 me-2">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content class="me-n16">
            <v-list-item-title class="me-n16 my-n3">
              <v-badge
                :color="item.badge > 0 ? 'accent' : 'transparent'"
                :label="item.badge > 999 ? '999+' : '' + item.badge"
                :content="item.badge > 999 ? '999+' : item.badge"
                offset-y="10"
                offset-x="0"
                class="my-5"
                >{{ item.title }}
              </v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item
          color="sidebarActive"
          v-for="(child, i) in item.subitems"
          :key="i"
          v-model="child.model"
          :href="'/#' + child.link"
          link
        >
          <v-list-item-action v-if="child.icon">
            <v-icon>
              {{ child.icon }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="ms-15 my-n3">
              <v-badge
                :color="child.badge > 0 ? 'accent' : 'transparent'"
                :label="child.badge > 999 ? '999+' : '' + child.badge"
                :content="child.badge > 999 ? '999+' : child.badge"
                offset-y="10"
                offset-x="0"
                class="my-5"
                >{{ child.title }}
              </v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item
        color="sidebarActive"
        v-else
        :key="item.title"
        v-model="item.model"
        :href="'/#' + item.link"
        link
      >
        <v-list-item-action class="ms-5 me-2">
          <v-icon>
            {{ item.icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="my-n3">
            <v-badge
              :color="item.badge > 0 ? 'accent' : 'transparent'"
              :label="item.badge > 999 ? '999+' : '' + item.badge"
              :content="item.badge > 999 ? '999+' : item.badge"
              offset-y="10"
              offset-x="0"
              class="my-5"
              >{{ item.title }}
            </v-badge>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<style scoped>
.v-icon.v-icon {
  font-size: 12px;
  width: 20px;
  text-align: center;
}
</style>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import AccountUsers from "@/api/account_users";

// var homeNav = {
//   title: i18n.t("Nav.home"),
//   icon: "fa-home",
//   link: "/home",
//   model: true,
// };

export default {
  name: "Nav",

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["accountUser", "allow", "settings"]),
  },

  props: {
    locale: String,
  },

  data: () => ({
    items: [],
  }),

  watch: {
    $route() {
      this.items = this.makeItems();
      AccountUsers.my(true); // 每次路由变化都刷新权限和设置
    },
    locale: {
      immediate: true,
      handler() {
        this.items = this.makeItems();
      },
    },
    allow: {
      immediate: true,
      deep: true,
      handler() {
        this.items = this.makeItems();
      },
    },
    settings: {
      immediate: true,
      deep: true,
      handler() {
        this.items = this.makeItems();
      },
    },
    accountUser: {
      immediate: true,
      deep: true,
      handler() {
        this.items = this.makeItems();
      },
    },
  },

  methods: {
    makeItems() {
      var nav = [];
      // nav.push(
      //   Object.assign({}, homeNav, {
      //     model:
      //       this.$route.path == homeNav.link ||
      //       this.$route.path.startsWith(homeNav.link + "/"),
      //   })
      // );

      var navItems;
      if (this.$route.path == "/my") {
        navItems = this.navs();
      } else if (
        this.$route.path == "/settings" ||
        this.$route.path == "/print-templates"
      ) {
        navItems = this.setNavs();
      } else {
        navItems = this.navs();
      }

      if (this.allow) {
        navItems.forEach((item) => {
          if (item.subitems) {
            var allowedSubitems = [];
            var itemModel = false;
            var itemBadge = 0;
            item.subitems.forEach((subitem) => {
              let controller = this.allow[subitem.controller];
              if (!subitem.controller) {
                subitem.model =
                  this.$route.path == subitem.link ||
                  this.$route.path.startsWith(subitem.link + "/");
                itemModel = itemModel || subitem.model;
                itemBadge += subitem.badge ? subitem.badge : 0;
                allowedSubitems.push(subitem);
              } else if (controller) {
                if (
                  controller.find((action) => subitem.action == action) &&
                  (!subitem.show || subitem.show())
                ) {
                  subitem.model =
                    this.$route.path == subitem.link ||
                    this.$route.path.startsWith(subitem.link + "/");
                  itemModel = itemModel || subitem.model;
                  itemBadge += subitem.badge ? subitem.badge : 0;
                  allowedSubitems.push(subitem);
                }
              }
            });
            if (allowedSubitems.length > 0) {
              item.subitems = allowedSubitems;
              item.model = itemModel;
              item.badge = itemBadge;
              nav.push(item);
            }
          } else {
            if (!item.controller) {
              item.model =
                this.$route.path == item.link ||
                this.$route.path.startsWith(item.link + "/");
              nav.push(item);
            } else {
              let controller = this.allow[item.controller];
              if (controller) {
                if (
                  controller.find((action) => item.action == action) &&
                  (!item.show || item.show())
                ) {
                  item.model =
                    this.$route.path == item.link ||
                    this.$route.path.startsWith(item.link + "/");
                  nav.push(item);
                }
              }
            }
          }
        });
      }
      return nav;
    },
    myNavs() {
      return [
        {
          title: i18n.t("Nav.backHome"),
          link: "/home",
          controller: "Suppliers",
          action: "view",
        },
      ];
    },
    setNavs() {
      return [
        {
          title: i18n.t("Nav.backHome"),
          link: "/home",
          controller: "Suppliers",
          action: "view",
        },
        {
          title: i18n.t("Nav.supplierSetting"),
          link: "",
          subitems: [
            {
              title: i18n.t("Nav.printSetting"),
              link: "/print-templates",
              controller: "",
              action: "index",
            },
            // {
            //   title: i18n.t("Nav.expressSetting"),
            //   link: "",
            //   controller: "",
            //   action: "index",
            // },
          ],
        },
      ];
    },
    navs() {
      let navs = [
        // 订单管理
        {
          title: i18n.t("Nav.orderManagement"),
          // icon: "",
          link: "/delivery",
          subitems: [
            {
              title: i18n.t("Nav.deliveryDetail"),
              link: "/delivery",
              controller: "Purchases",
              action: "index",
            },
            {
              title: i18n.t("Nav.questionIndex"),
              link: "/question",
              controller: "Quotations",
              action: "index",
            },
            {
              title: i18n.t("Nav.economiesIndex"),
              link: "/economies",
              controller: "Economies",
              action: "index",
            },
            {
              title: i18n.t("Nav.stockOutsIndex"),
              link: "/stock-outs",
              controller: "StockOuts",
              action: "index",
            },
          ],
        },
        // 采购管理
        {
          title: i18n.t("Nav.purchases"),
          // icon: "",
          link: "/purchases",
          subitems: [
            {
              title: i18n.t("Nav.purchasesList"),
              link: "/purchases",
              controller: "Purchases",
              action: "index",
              show: function () {
                return (
                  this.settings &&
                  this.settings.supplier_self_purchase &&
                  this.settings.self_purchase_flg
                );
              }.bind(this),
            },
          ],
        },
        // 账单管理
        {
          title: i18n.t("Nav.billManagement"),
          // icon: "",
          link: "/receipt",
          subitems: [
            {
              title: i18n.t("Nav.receiptDetail"),
              link: "/receipt",
              controller: "Receipt",
              action: "index",
            },
          ],
        },
        // 商品管理
        {
          title: i18n.t("Nav.materialManagement"),
          // icon: "",
          link: "/supplier-materials",
          subitems: [
            {
              title: i18n.t("Nav.materials"),
              link: "/supplier-materials",
              controller: "SupplierMaterials",
              action: "index",
            },
          ],
        },
      ];
      if (this.accountUser && this.accountUser.supplier.cloud_print_flg) {
        navs.push({
          title: i18n.t("Nav.cloudPrinterSetting"),
          // icon: "",
          link: "/settings/cloud-printer-setting",
          subitems: [
            {
              title: i18n.t("SettingNav.cloudPrinterSetting"),
              link: "/cloud-printer-setting",
              controller: "CloudPrints",
              action: "index",
            },
            {
              title: i18n.t("SettingNav.cloudPrinterDesign"),
              link: "/cloud-print-templates",
              controller: "CloudPrintTemplates",
              action: "index",
            },
          ],
        });
      }
      navs.push({
        title: i18n.t("Nav.reportCenter"),
        // icon: "",
        link: "/material-analyze",
        subitems: [
          {
            title: i18n.t("Nav.materialAnalyze"),
            link: "/material-analyze",
          },
          {
            title: i18n.t("Nav.reportDownloads"),
            link: "/report-downloads",
            controller: "ReportDownloads",
            action: "index",
          },
        ],
      });

      return navs;
    },
  },
};
</script>